// Devise et conversion tarifaire — admin.
//
// Décision métier (vague « cohérence tarifaire », oct. 2026) :
// - Tous les tarifs sont saisis et stockés en XAF côté serveur (source de
//   vérité : ServicePricing.base_price, Agent.basePrice, ServiceDetail.agentPrice).
// - Le paiement est toujours en EUR côté client ; l'admin saisit en XAF et voit
//   l'équivalent EUR à titre indicatif (préfixe « ≈ »).

// Parité fixe franc CFA : 1 EUR = 655,957 XAF (constante, pas d'API de taux).
export const XAF_PER_EUR = 655.957;

// XAF -> EUR, arrondi au centime le plus proche.
export function xafToEur(amountXaf) {
  const value = Number(amountXaf);
  if (!Number.isFinite(value)) return 0;
  return Math.round((value / XAF_PER_EUR) * 100) / 100;
}

// EUR -> XAF, arrondi au franc le plus proche.
export function eurToXaf(amountEur) {
  const value = Number(amountEur);
  if (!Number.isFinite(value)) return 0;
  return Math.round(value * XAF_PER_EUR);
}

// Formate un montant XAF en français (ex. « 8 855 FCFA »).
export function formatXaf(amountXaf) {
  const value = Number(amountXaf);
  if (!Number.isFinite(value)) return '-';
  return new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'XAF',
    maximumFractionDigits: 0,
  }).format(value);
}

// Équivalent EUR indicatif d'un montant XAF (ex. « ≈ 13,50 € »).
export function formatEurFromXaf(amountXaf) {
  const value = Number(amountXaf);
  if (!Number.isFinite(value)) return '-';
  return `≈ ${new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(xafToEur(value))}`;
}
